import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faTimes,
  faBars,
  faCalendar,
  faDoorOpen,
} from "@fortawesome/free-solid-svg-icons";
import SubMenu from "./SubMenu";
import { Nav, Button } from "react-bootstrap";
import styles from "./Sidebar.styles.js";
import { logoutUser } from "../../utils/api/authentication.js";
import { refreshPage } from "../../utils/commons";
import CustomToast from "../CustomToast";
import { NavLink } from "react-router-dom";

function SideBar({ toggle, isOpen }) {
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  // check if there is changes in screen size
  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  const handleLogout = async () => {
    const response = await logoutUser();
    if (response.status === 200) {
      setMessage({ message: response?.data?.message, type: "success" });
      setShowToast(true);
      refreshPage();
    } else {
      const responseMessage = response?.data?.messages?.error;
      setMessage({ message: responseMessage, type: "danger" });
      setShowToast(true);
      refreshPage();
    }
  };

  return (
    <>
      <Nav
        className='flex-column'
        style={isOpen ? styles.sidebar["&.open"] : styles.sidebar}
      >
        {/* Add Logo */}
        <Nav.Item className='nav-item'>
          <Nav.Link href='/' className='nav-link'>
            <img
              src='../../logo.png'
              alt='logo'
              className='img-fluid w-50 mx-auto d-block'
            />
          </Nav.Link>
          <Nav.Link onClick={toggle} className='position-fixed top-0 end-0'>
            <FontAwesomeIcon
              icon={isOpen ? faTimes : faBars}
              style={width > 720 ? { fontSize: "2rem" } : { fontSize: "1rem" }}
            />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <NavLink to='/store' className='nav-link' style={styles.navLink}>
            <FontAwesomeIcon icon={faHome} className='me-2' />
            Store
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to='/attendance' className='nav-link' style={styles.navLink}>
            <FontAwesomeIcon icon={faCalendar} className='me-2' />
            Attendance
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to='/user' className='nav-link' style={styles.navLink}>
            <FontAwesomeIcon icon={faUser} className='me-2' />
            User
          </NavLink>
        </Nav.Item>

        {/* 
                <SubMenu
                    title="Pages"
                    icon={faCopy}
                    items={["NavLink", "Link2", "Active"]}
                /> */}

        {/* <Nav.Item>
                    <NavLink to="/" style={styles.navLink}>
                        <FontAwesomeIcon icon={faUser} className="mr-2" />
                        Users
                    </NavLink>
                </Nav.Item> */}

        <Nav.Item>
          <Nav.Link onClick={handleLogout} style={styles.navLink}>
            <FontAwesomeIcon icon={faDoorOpen} className='me-2' />
            Logout
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Button
        style={isOpen ? styles.bubbleButton : styles.bubbleButton["&.open"]}
        onClick={toggle}
        hidden={window.location.pathname === "/public_map"}
      >
        <FontAwesomeIcon icon={isOpen ? faTimes : faBars} className='mr-2' />
      </Button>
      <CustomToast
        type={details.type}
        message={details.message}
        title='Logout'
        show={showToast}
        setShow={setShowToast}
      />
    </>
  );
}

export default SideBar;
